import { render } from "./ConfirmDialog.vue?vue&type=template&id=83a07816&ts=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&lang=ts"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=83a07816&lang=css"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/ConfirmDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "83a07816"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('83a07816', __exports__)) {
    api.reload('83a07816', __exports__)
  }
  
  module.hot.accept("./ConfirmDialog.vue?vue&type=template&id=83a07816&ts=true", () => {
    api.rerender('83a07816', render)
  })

}


export default __exports__